import { CollapsibleTile, CollapsibleTileSize } from '@box-types';
import { generateTagOptions, generateTitleSizeClass, getHostClasses } from '@box/utils';
import React, { memo, useMemo } from 'react';
import { PromoTagComponent } from '../promo-tag';
import cn from 'classnames';
import { AngularWrapper } from '../angular-wrapper/angular-wrapper';
import { MatIcon } from '@angular/material/icon';
import isEqual from 'lodash-es/isEqual';

type CollapsibleTileProps<T> = {
  collapsed: boolean;
  size: CollapsibleTileSize;
  tile: CollapsibleTile<T>;
  className?: string;
};

function CollapsibleTileComponent<T>({ collapsed, size, tile, className }: CollapsibleTileProps<T>) {
  const expandedTileSizeClass = getHostClasses(size);
  const titleSizeClass = generateTitleSizeClass(tile?.title || '');
  const tagOptions = useMemo(() => generateTagOptions(tile), [tile]);

  const tileState = useMemo(() => {
    if (!tile) return null;
    return {
      ...tile,
      backGroundColor: tile.backGroundColor ?? '#5a5a5a',
      textColor: tile.textColor ?? '#ffffff',
      image: `url('${tile.image}')`,
      collapsedImage: `url('${tile.collapsedImage}')`,
      multiplier: tile.multiplier ?? 1,
      points: tile.points ?? 1
    };
  }, [tile]);

  if (!tileState) return null;

  return (
    <>
      {collapsed ? (
        <div
          className={cn(className, 'collapsed-tile-component')}
          style={{ color: tileState.textColor, backgroundColor: tileState.backGroundColor }}
        >
          <AngularWrapper component={MatIcon} className="collapsible-tile-component-icon">
            expand_more
          </AngularWrapper>
          <div className="collapsed-tile-component-title ods-typography-subtitle-s">{tileState.collapsedTitle}</div>
          {tagOptions && <div>todo points tag component</div>}
          <div
            className="collapsed-tile-component-image-background"
            style={{ backgroundImage: tileState.collapsedImage }}
          />
        </div>
      ) : (
        <div
          className={cn(className, 'expanded-tile-component', expandedTileSizeClass)}
          aria-disabled={tileState.disabled}
          style={{ color: tileState.textColor, backgroundColor: tileState.backGroundColor }}
        >
          {tagOptions && (
            <PromoTagComponent
              className="box-promo-tag expanded-tile-component-tag"
              options={tagOptions}
              enableAnimations={false}
            />
          )}
          <div className={`expanded-tile-component-title ods-typography-subtitle-s ${titleSizeClass}`}>
            {tileState.title}
          </div>
          <div className="expanded-tile-component-image-background" style={{ backgroundImage: tileState.image }} />
        </div>
      )}
    </>
  );
}

const areEqual = (prevProps, nextProps) => {
  return isEqual(prevProps, nextProps);
};
export default memo(CollapsibleTileComponent, areEqual);
